import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async (params = {}) => {
  return await dponetAPI.get('/complaint_categories', { params })
}

const show = async (categoryId) => {
  return await dponetAPI.get(`/complaint_categories/${categoryId}`)
}

const create = async (data) => {
  return await dponetAPI.post('/complaint_categories', data)
}

const update = async (categoryId, data) => {
  return await dponetAPI.put(`/complaint_categories/${categoryId}`, data)
}

const registerResponsibles = async ({ categoryId, responsiblesIds }) => {
  return await dponetAPI.put(
    `/complaint_categories/${categoryId}/responsibles`,
    {
      complaintCategory: { responsiblesIds },
    },
  )
}

const logs = async (categoryId) => {
  return await dponetAPI.get(`/complaint_categories/${categoryId}/logs`)
}

const complaintCategories = {
  get,
  show,
  create,
  update,
  registerResponsibles,
  logs,
}

export default complaintCategories
